import { useGetSocialMediaInfluencerV2 } from "@entities/influencer/lib/hooks/useGetSocialMediaInfluencerV2";
import { Flex, Row, Spin } from "antd";
import { AudienceInsights } from "./AudienceInsights";
import { BasicData } from "./BasicData";
import { PerformanceTile } from "./PerformanceTile";
import { ProcessingNotice } from "./ProcessingNotice";

interface Props {
  socialMediaId: string;
  platform: string;
}

export function InsightsData({ socialMediaId, platform }: Props) {
  const { socialMediaInfluencer, isFetching, isError, refetch } =
    useGetSocialMediaInfluencerV2(socialMediaId);

  if (isFetching) {
    return (
      <Row justify="center" align="middle" style={{ height: "100%" }}>
        <Spin />
      </Row>
    );
  }

  if (isError) {
    return <div>Error</div>;
  }

  return (
    <Flex vertical gap={12}>
      {(socialMediaInfluencer?.basicInsightsStatus !== "Completed" ||
        socialMediaInfluencer?.audienceInsightsStatus !== "Completed") && (
        <ProcessingNotice onReload={refetch} isReloading={isFetching} />
      )}
      <BasicData
        basicData={socialMediaInfluencer?.userBasicDetails}
        basicInsights={socialMediaInfluencer?.userBasicInsights}
        platform={platform}
      />
      <PerformanceTile
        performanceInsights={socialMediaInfluencer?.performanceUserMedia}
        platform={platform}
        username={socialMediaInfluencer?.userBasicDetails?.username || ""}
      />
      <AudienceInsights
        audienceInsights={socialMediaInfluencer?.audienceUserInsights}
        platform={platform}
      />
    </Flex>
  );
}
